import { MotivationPrinciple } from "../motivationPrinciple.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class MotivationPrincipleSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new MotivationPrinciple();
        this._copyAttributes(gp, data);
        return gp;

    }

}
